import { render, staticRenderFns } from "./AssignExpertModal.vue?vue&type=template&id=bad00cdc&scoped=true"
import script from "./AssignExpertModal.vue?vue&type=script&lang=js"
export * from "./AssignExpertModal.vue?vue&type=script&lang=js"
import style0 from "./AssignExpertModal.vue?vue&type=style&index=0&id=bad00cdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad00cdc",
  null
  
)

export default component.exports